import { FaArrowRight } from "react-icons/fa6";
import "./index.css";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";

const CourseCards = () => {
  const { setModalShow, coursesRef } = useContext(AppContext);
  const [aboutCourse, setAboutCourse] = useState([]);
  const courseData = [
    {
      courseId: 0,
      course: "Full Stack Development",
      imageUrl:
        "https://iqteche.in/static/media/wl_client_images/14761e95dc48417689a6a70ba5dc066d.jpeg",
      title: "Master MERN Stack & Build Production-Ready Applications.",
      eligibility: [
        { education: "12th / Inter" },
        { education: "Any Degree" },
        { education: "BTech" },
      ],
      nextBatch: "Starting Soon",
      seatsAvl: "Limited Seats Available",
      link: "/fullstack",
    },
    {
      courseId: 1,
      course: "Specializations - AIML, DS, etc",
      imageUrl:
        "https://iqteche.in/static/media/wl_client_images/22a149edfa384fb89554029d23c6b0d3.jpg",
      title:
        "Learn 4.0 Advance Technologies like AI/ML, Data Science, Cyber Security...",
      eligibility: [{ education: "Any Degree" }, { education: "BTech" }],
      nextBatch: "Starting Soon",
      seatsAvl: "Limited Seats Available",
      link: "/specializations",
    },
    {
      courseId: 2,
      course: "Tech Tools",
      imageUrl:
        "https://iqteche.in/static/media/wl_client_images/262cab2a1a0346ada7a829d09ea325c9.jpeg",
      title: "Learn Tech Tools Like AWS, SAP, ServiceNow and PowerBi.",
      eligibility: [{ education: "Any Degree" }, { education: "BTech" }],
      nextBatch: "Starting Soon",
      seatsAvl: "Limited Seats Available",
      link: "/tech-tools",
    },
  ];

  // useEffect(() => {
  //   const getCourseCardData = async () => {
  //     try {
  //       const response = await fetch(
  //         "https://ibix-server.onrender.com/api/ibix/course"
  //       );
  //       if (response.ok) {
  //         const responseData = await response.json();
  //         const formattedData = responseData.data.map((item, index) => ({
  //           courseId: item.course_id,
  //           imageUrl: item.image_url,
  //           title: item.title,
  //           eligibility: item.eligibility,
  //           nextBatch: item.next_batch,
  //           seatsAvl: item.seats_avl,
  //         }));
  //         setCourseData(formattedData);
  //       }
  //     } catch (error) {
  //       console.log(error.message);
  //     }
  //   };

  //   getCourseCardData();
  // }, []);
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await fetch(
          "https://script.googleusercontent.com/macros/echo?user_content_key=AehSKLh58Z8YhU-2OiaibstQReZTNhg68yibTaDR9nptRN1WUPNccv9U_t-jjWReCnOH4BAvJO0BCshLnti86b_6sLw4P0W7tSoYR6MNKHKMpL0NKVSfhxy60PV-K5E_qgn6YE7iVYHHbNm9OLJ364paX3q35cTOF7paebraKcraICGfVAnlvnKZrPTGEu26u9FU2Y8dP1p8pIUz3J6o-T0arEtkiGmEPC3wEHSLK1EfctpHuC5QbS2qq__4tST3SNYIwk_AfvhyNyiDY3Q2LrTXUPbXIAL8l0stQh_u0jzw&lib=MmYkaqxGMYECekCOmtesB0nOADDUrIbO7",
          {
            method: "GET",
            mode: "cors", // ✅ use "cors", NOT "no cors"
          }
        );
        const data = await res.json();
        setAboutCourse(data);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchDetails();
  }, []);

  return (
    <section id="courses" className="courses-bg-container" ref={coursesRef}>
      <div className="container d-flex flex-column align-items-center">
        <h1 className="text-center">
          Explore Our Industry Relevant IT Courses
        </h1>
        <p className="text-center">
          Learn in-demand IT skills with real-world projects and expert
          guidance.
        </p>

        <div className="row">
          {courseData.map((item, index) => (
            <div
              className="col-sm-12 col-md-6 col-lg-4"
              key={`course-col-${index}`}
            >
              <div className="academy-card mb-3" id={`academy-card-${index}`}>
                <div className="card-header">
                  <img
                    src={item.imageUrl}
                    alt={`${item.course} Course`}
                    className="course-card-image"
                  />
                </div>

                <p className="course-name-shine">{item.course}</p>

                <div className="badges">
                  {item.eligibility.map((edu, eduIndex) => (
                    <span
                      className="badge purple"
                      key={`badge-${index}-${eduIndex}`}
                      id={`badge-${index}-${eduIndex}`}
                    >
                      {edu.education}
                    </span>
                  ))}
                </div>

                <p className="headline">{item.title}</p>

                <div className="batch-info">
                  <p className="next-batch">
                    NEXT BATCH <br />
                    {aboutCourse.length > 0 ? (
                      <span>{aboutCourse[index].next_batch}</span>
                    ) : (
                      <span className="my-spinner d-flex justify-content-center">
                        <PulseLoader color="#000000" size={8} loading={true} />
                      </span>
                    )}
                  </p>

                  <p className="next-batch">
                    SEATS <br />
                    {aboutCourse.length > 0 ? (
                      <span>{aboutCourse[index].seats_avl}</span>
                    ) : (
                      <span className="my-spinner d-flex justify-content-center">
                        <PulseLoader color="#000000" size={8} loading={true} />
                      </span>
                    )}
                  </p>
                </div>

                <button
                  className="callback-btn"
                  onClick={() => setModalShow(true)}
                >
                  📞 Request Callback
                </button>

                <p className="know-more">
                  <Link to={`/courses${item.link}`} className="know-more-link">
                    Know More <FaArrowRight />
                  </Link>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CourseCards;
